import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
export const errorConstants = {
  400: {
    status: 'Bad request',
    message: <Message id="error.invalid.request" />,
  },
  401: {
    status: 'Unauthorized',
    message: <Message id="error.access.denied" />,
  },
  403: {
    status: 'Forbidden',
    message: <Message id="error.no.permission" />,
  },
  404: {
    status: 'Not found',
    message: <Message id="error.not.found" />,
  },
  409: {
    status: 'Conflict',
    message: <Message id="error.already.exist" />,
  },
  500: {
    status: 'Internal server error',
    message: <Message id="error.something.wrong" />,
  },
  502: {
    status: 'Bad gateway',
    message: <Message id="error.something.wrong" />,
  },
  503: {
    status: 'Service unavailable',
    message: <Message id="error.service.unavailable" />,
  },
}
